import { Box } from "@mui/material";
import { FooterSection } from "./sections/FooterSection";
import { HeaderSection } from "./sections/HeaderSection";
import { MainContentSection } from "./sections/MainContentSection";

export const AboutUsPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.paper",
        width: "100%",
      }}
    >
      <MainContentSection />
    </Box>
  );
};
